<template>
  <div class="animated fadeIn vld-parent custom-100">
    <b-tabs content-class="mt-3" style="padding-left: 2px; background: #fbfbfb;" v-model="currentTab">
      <b-tab title="Posteingang"></b-tab>
      <b-tab title="Chats"></b-tab>
    </b-tabs>
  <inbox v-if="currentTab === 0"></inbox>
  <messaging v-else></messaging>
  </div>
</template>

<script>
import Inbox from './Inbox.vue'
import Messaging from '@/views/messaging/messaging.vue'

export default {
  name: "BisInbox",
  components: {
    Inbox,
    Messaging
  },
  data() {
    return {
      currentTab: 0,
    }
  },
}
</script>

<style scoped>
::v-deep .tab-content {
  display: none !important;
}

::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-link.active:focus {
  background-color: transparent;
}
</style>
